import { SectionNewsletterProps } from '@portfolio/models'
import {
  Media,
  PortableText,
  SectionWrapper,
  Link,
} from '@portfolio/components'
import { styled } from '@portfolio/styles'

const ContentWrapper = styled('div', {
  border: `1px solid`,
  borderRadius: '$r3',
  margin: `0 $32`,
  padding: '$40',
  backgroundColor: '$techstackCardsBackground',

  variants: {
    theme: {
      light: {
        color: '$black',
        borderColor: '$socialsGray',
        backgroundColor: '$socialsGray',
      },
      dark: {
        color: '$white',
        borderColor: '$techstackCardsBackground',
        backgroundColor: '$techstackCardsBackground',
      },
    },
  },
})

const Heading = styled('h2', {
  projectFont: 'heading05',
  marginBottom: '$16',
})

const Description = styled('p', {
  projectFont: 'heading08',
  marginBottom: '$20',
})

const Author = styled('div', {
  display: 'grid',
  gridTemplate: `
                'avatar details'
                '. description'
              `,
  alignItems: 'center',
  gridTemplateColumns: '60px auto',
  gridRowGap: '$8',
  gridColumnGap: '$32',
  marginTop: '$96',
})

const Avatar = styled('div', {
  overflow: 'hidden',
  borderRadius: '$rMax',
  width: 80,
  height: 80,
  gridArea: 'avatar',
})

const Name = styled('p', {
  projectFont: 'body03',
})
const Position = styled('p', {
  projectFont: 'body03',
  variants: {
    theme: {
      light: {
        color: '$black_05',
      },
      dark: {
        color: '$white_05',
      },
    },
  },
})
const Details = styled('div', {
  gridArea: 'details',
})

const StyledLink = styled(Link, {
  display: 'inline-block',
  projectFont: 'ui01',
  border: '1px solid $white_02',
  padding: '$12 $24',
  borderRadius: '$rMax',
  backgroundColor: '$white_02',
  textAlign: 'center',

  variants: {
    theme: {
      light: {
        borderColor: '$black',
        color: '$black',
      },
      dark: {
        borderColor: 'transparent',
        color: '$white',
      },
    },
  },
})

export const SectionNewsletter = ({
  theme,
  title,
  description,
  authors,
  ctaLabel,
  ctaLink,
}: SectionNewsletterProps) => {
  return (
    <SectionWrapper>
      <ContentWrapper theme={theme}>
        <Heading>{title}</Heading>
        <Description>{description}</Description>
        {ctaLink && ctaLabel && (
          <StyledLink theme={theme} {...ctaLink}>
            {ctaLabel}
          </StyledLink>
        )}
        <div>
          {authors &&
            authors?.map((author, index) => (
              <Author
                as={author?.linkedin ? Link : 'div'}
                href={author?.linkedin}
                target="_blank"
                key={`${author?.name}-${index}`}
              >
                <Avatar>
                  {author?.avatar && <Media {...author?.avatar} sizes="80px" />}
                </Avatar>
                <Details>
                  <Name>{author?.name}</Name>
                  <Position theme={theme}>{author?.position}</Position>
                </Details>
                {author?.description && (
                  <Description>
                    <PortableText
                      value={author?.description}
                      appearance="plain"
                    />
                  </Description>
                )}
              </Author>
            ))}
        </div>
      </ContentWrapper>
    </SectionWrapper>
  )
}
